import React from 'react';
import { Grid, Typography, Link } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import { Link as LinkAnim} from "react-scroll";
import './workStyles.css'


function OurWorkFeatured() {
  const globalClasses = globalUseStyles()
  return (
<ThemeProvider theme={theme}>
   <Container className={globalClasses.featuredContainer} maxWidth={false} component="section">
      <Grid className={globalClasses.containerSmall} container >
         <Grid item xs={12} md={12}  >
            <Typography variant="subtitle1">Our Work</Typography>
            <Typography  variant="h1">We provide expertise that solve problems.</Typography>
            <Typography  variant="body1">Part of what makes us unique is the ethos we reflect when approaching our work. We work with organizations to design and develop innovative solutions that improve the lives of the people who use them. </Typography>
            <Typography variant="body1">
            <LinkAnim 
              className={'animLink'}
              to="casestudies"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}>
               <Link to='/case' className={"link link--arrowed centered"} color="primary" >View Case Studies
                     <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                        <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                        <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                        </g>
                     </svg>
               </Link>
              </LinkAnim>
            </Typography>
         </Grid>
      </Grid>
   </Container>
</ThemeProvider>
  );
};

export default OurWorkFeatured;